import { MouseEvent, useCallback, useId, useState } from 'react';

import Button from '@pelckmans/elementis/components/button';
import DropdownMenu from '@pelckmans/elementis/components/dropdown-menu';
import Options from '@pelckmans/elementis/icons/options';

export default function ActionMenuButton({
  children,
  disabled,
  zIndex,
  buttonProps,
  menuProps,
}: {
  children: (handleToggle: () => void) => React.ReactNode;
  disabled?: boolean;
  zIndex?: number;
  buttonProps: {
    ariaLabel: string;
  };
  menuProps: {
    ariaLabel: string;
  };
}) {
  const menuId = useId();

  const [buttonEl, setButtonEl] = useState<HTMLButtonElement | null>(null);

  const [open, setOpen] = useState(false);

  const handleToggle = useCallback((e?: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e?.preventDefault();

    setOpen(prev => !prev);
  }, []);

  function handleCollapse(e?: Event) {
    if (!open || buttonEl?.contains(e?.target as Node)) return;

    handleToggle();
  }

  return (
    <>
      <Button
        prominence="neutral"
        startIcon={<Options />}
        aria-label={buttonProps.ariaLabel}
        size="sm"
        onClick={handleToggle}
        ref={(el: HTMLButtonElement) => setButtonEl(el)}
        data-testid="action-menu-button"
        disabled={disabled}
      />
      {open && (
        <DropdownMenu
          actionEl={buttonEl}
          referenceEl={buttonEl}
          role="menu"
          menuProps={{
            ariaLabel: menuProps.ariaLabel,
            id: menuId,
          }}
          selectableByEnter
          onCollapse={handleCollapse}
          grow
          flip
          zIndex={zIndex}
          disableBackgroundScroll
        >
          {children(handleToggle)}
        </DropdownMenu>
      )}
    </>
  );
}
